import {Component, OnInit, OnDestroy, ElementRef, Input, Output, EventEmitter} from '@angular/core';
import * as _ from 'lodash';
import {CommonCommponentsService} from '../common-commponents.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {dealError} from '../../error-handler';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-table-custom-setting',
  templateUrl: './table-custom-setting.component.html',
  styleUrls: ['./table-custom-setting.component.scss'],
})
export class TableCustomSettingComponent implements OnInit, OnDestroy {

  modalDisabled = false;
  isSpinning = false;
  allChecked = false;
  indeterminate = false;
  _settingItem: any = null;
  tempSettingItem: any = null;
  fields: any = null;
  itemsList: any[] = [];
  _settingVisible: any = null;

  @Input()
  set settingItem(v) {
    if (v) {
      this._settingItem = _.cloneDeep(v);
      this.tempSettingItem = _.cloneDeep(v);
      this.fields = JSON.parse(this._settingItem.fields);
      this.itemsList = _.orderBy(this.fields.items, ['sort'], ['desc']);
      this.updateSingleChecked();
    }
  }

  get settingItem() {
    return this._settingItem;
  }

  @Input()
  set settingVisible(v) {
    this._settingVisible = v;
  }

  get settingVisible() {
    return this._settingVisible;
  }

  @Output() settingFinish = new EventEmitter();
  constructor(
    public dataService: CommonCommponentsService,
    private message: NzMessageService,
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  handleCloseModal() {
    this._settingItem = this.tempSettingItem;
    this.settingFinish.emit(false);
  }

  updateAllChecked() {
    this.indeterminate = false;
    if (this.allChecked) {
      this.itemsList = this.itemsList.map(item => {
        if (item.isBool) {
          return item;
        } else {
          return {
            ...item,
            isShow: true
          };
        }
      });
    } else {
      this.itemsList = this.itemsList.map(item => {
        if (item.isBool) {
          return item;
        } else {
          return {
            ...item,
            isShow: false
          };
        }
      });
    }
  }

  updateSingleChecked() {
    if (this.itemsList.every(item => !item.isShow)) {
      this.allChecked = false;
      this.indeterminate = false;
    } else if  (this.itemsList.every(item => item.isShow)) {
      this.allChecked = true;
      this.indeterminate = false;
    } else {
      this.indeterminate = true;
    }
  }

  handleItemsSort() {
    const showItemsList = _.filter(this.itemsList, o => o.isShow);
    const hiddenItemsList = _.filter(this.itemsList, o => !o.isShow);
    this.itemsList = _.concat(showItemsList, hiddenItemsList);
    for (let i = this.itemsList.length; i > 0; i--) {
      this.itemsList[this.itemsList.length - i].sort = i;
      this.itemsList[this.itemsList.length - i].width = Math.abs(this.itemsList[this.itemsList.length - i].width);
    }
  }

  submitTable() {
    this.handleItemsSort();
    this.fields.items = this.itemsList;
    this._settingItem.fields = JSON.stringify(this.fields);
    this.isSpinning = true;
    this.modalDisabled = true;
    this.dataService.updateSystemTableSetting(this._settingItem).subscribe(
      data => {
        this.isSpinning = false;
        this.modalDisabled = false;
        this.settingFinish.emit(this._settingItem);
      },
      error => {
        this.isSpinning = false;
        this.modalDisabled = false;
        this.message.create('error', dealError('更新配置', error));
      }
    );
  }

  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.itemsList, event.previousIndex, event.currentIndex);
  }

  moveToTop(item: any): void {
    const index = this.itemsList.indexOf(item);
    if (index > 0) {
      this.itemsList.splice(index, 1);
      this.itemsList.unshift(item);
    }
  }
}
